import dayjs from 'dayjs';

import type {TimeslotData} from './types';

import {
  datetimeObjToISOString,
  ISOStringToDatetimeObj,
} from '../../utils/datetime';
import {FlagManager} from '../../utils/store';
import {SHORT_DATE_FORMAT} from './utils/constants';

export class TimeslotModel {
  id: string;
  isActive = new FlagManager();
  isSelected = new FlagManager();
  startDateDjs: dayjs.Dayjs;
  startDateTimestamp: number;

  constructor(
    public startDate: TimeslotData['start_date'],
    isActive = false,
    public coachId?: string,
  ) {
    this.id = TimeslotModel.createId(this.startDate);
    this.startDateDjs = dayjs(this.id);
    this.startDateTimestamp = this.startDateDjs.toDate().valueOf();

    if (isActive) {
      this.isActive.setTrue();
    }
  }

  get hour() {
    return this.startDateDjs.hour();
  }

  get label() {
    return this.startDateDjs.format(SHORT_DATE_FORMAT);
  }

  get minute() {
    return this.startDateDjs.minute();
  }

  static createId(startDate: TimeslotData['start_date']) {
    return datetimeObjToISOString(startDate);
  }

  makeRequestParams(durationMinutes: number) {
    return {
      end_date: ISOStringToDatetimeObj(
        this.startDateDjs.add(durationMinutes, 'minutes').toISOString(),
      ),
      start_date: ISOStringToDatetimeObj(this.startDateDjs.toISOString()),
    };
  }
}
